import { useContext, useState, useEffect } from 'react';
import PersonalHeader from '../../PersonalDetails/components/header';
// import TableComponent from '../../TableComponent';
import FormGroup from '../../FormGroup';
import useFetchData from '../../../hooks/useFetchData';
import usePostData from '../../../hooks/usePostData';
import fields from '../fields';
import GlobalContext from '../../../contexts';
import { useParams } from 'react-router-dom';
import { isValidIsraeliID } from '../../../utils';
import globalTranslating from '../../../translate.json';
import terapistTranslating from '../translate.json';
import SnackBar from 'components/SnackBar';
import PersonalDetailsContent from 'components/PersonalDetails/components/content';

const TerapistPage = () => {
  // const navigate = useNavigate
  const translating = { ...globalTranslating, ...terapistTranslating };
  const { id: userUuid } = useParams();
  const { postData, res, payload, error } = usePostData();
  const { categoriesList, regionEnum, currentUser } = useContext(GlobalContext);
  const [currentTerapist, setCurrentTerapist] = useState({});
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [errFun, setErrFun] = useState();

  let { data: terapistData } = useFetchData(
    `user/therapist/findOne/${userUuid}`
  );

  useEffect(() => {
    setCurrentTerapist(terapistData);
  }, [terapistData]);

  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    }
    if (res && res.affected === 1) {
      setShowSnakbar(true);
    }
  }, [res, payload, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    if (!isValidIsraeliID(data.ssn))
      setError('ssn', {
        type: 'invalidTZ',
        message: translating.invalidTZ
      });
    else {
      let deepData = { ...data };
      delete deepData.id;
      console.log('update terapist data  :', deepData);
      postData(`user/therapist/${userUuid}`, deepData, 'patch');
    }
  };

  const roleUser = currentUser.role.name;
  const allowdRules = ['Admin', 'Manager', 'System'];
  const allowedUser = allowdRules.indexOf(roleUser) > -1;

  // const Availability = () => {
  //   return (
  //     <div className="avilability-section">
  //       <div className="avilability-title"> הגדרת זמינות</div>
  //       <div className="avilability-wrapper-table">
  //         <TableComponent
  //           headers={['1', '2', '3', '4', '5', '6']}
  //           rows={[]}
  //         ></TableComponent>
  //       </div>
  //     </div>
  //   );
  // }

  // const MeetingsList = () => {
  //   return (
  //     <div className="meetings-list">
  //       <div className="meetings-list-title">{translating.documentMeetings}</div>
  //       <TableComponent
  //         headers={['1', '2', '3', '4']}
  //         rows={[]}
  //       ></TableComponent>
  //     </div>
  //   );
  // }

  // const Upcomingmeetings = () => {
  //   return (
  //     <div className="upcoming-meetings">
  //       <div className="upcoming-meetings-title">{translating.upcomingMeetings}</div>
  //       <TableComponent
  //         headers={['1', '2', '3', '4']}
  //         rows={[]}
  //       ></TableComponent>
  //     </div>
  //   );
  // }

  const actions = [];

  return (
    <div className="terapist-page">
      {currentTerapist?.id && (
        <div>
          <div className="personal-details">
            <PersonalHeader
              title={translating.personalDetailsHeader}
              actions={actions}
            ></PersonalHeader>
            <div className="wrapper-details">
              <div className="customer-details">
                {allowedUser ? (
                  <FormGroup
                    fields={fields(categoriesList, regionEnum)}
                    data={currentTerapist}
                    onSubmit={onSubmit}
                  ></FormGroup>
                ) : (
                  <PersonalDetailsContent
                    data={currentTerapist}
                    fields={fields(categoriesList, regionEnum)}
                  ></PersonalDetailsContent>
                )}
              </div>
            </div>
          </div>

          {/* <div className="terapist-grid">
            <div className="terapist-meetings">
              <Upcomingmeetings></Upcomingmeetings>
              <MeetingsList></MeetingsList>
            </div>
            <div className="terapist-availability">
              <Availability></Availability>
            </div>
          </div> */}
        </div>
      )}
      {showSnackbar && (
        <SnackBar
          msg={'מטפל עודכן'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default TerapistPage;
